<template>
    <div class="articleSearch">
        <div class="luiyan-header">
            <div class="search-box">
                <input type="text" placeholder="输入内容" v-model="searchValue"/>
                <div class="submit-btn" @click="getLists">查询</div>
            </div>
        </div>
        <div class="luiyan-box">
            <div class="luiyan-box-title">
                <span>找到{{ total }}个结果</span>
            </div>
            <div class="luiyan-box-content">
                <div class="luiyan-box-content-item"
                     v-for="item in lists"
                     :key="item.id"
                     @click="handleClick(item)">
                    <div class="luiyan-box-content">
                        <div class="date">{{ item.month }}.{{ item.day }}</div>
                        <div class="year">{{ item.year }}</div>
                    </div>
                    <div class="content">
                        {{ item.title }}
                    </div>
                </div>
            </div>
            <div class="tc" v-if="total > pageSize">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    class="tc"
                    prev-text="上一页"
                    next-text="下一页"
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :total="total">
                </el-pagination>
                <br/>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, toRefs, onMounted } from 'vue';
import { articleLists } from '../api/index';
import moment from 'moment';
import { useRouter } from 'vue-router/composables';
import { useStore } from '@/util';

const router = useRouter();
const store = useStore();

const handleCurrentChange = (val) => {
    console.log(val);
};

const state = reactive({
    page: 1,
    total: 0,
    searchValue: '',
    lists: []
});
const { page, total, searchValue, lists } = toRefs(state);
// 获取列表
const getLists = () => {
    const data = {
        pageNo: state.page,
        pageSize: state.pageSize,
        keyword: state.searchValue
    };
    articleLists(data).then(({ data }) => {
        const _data = data?.list || [];
        _data.forEach(element => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        state.lists = _data;
        state.total = data.total;
    });
};

const handleClick = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        store.commit('setActiveRouteName', 'Information');
        router.push('/information/detail?id=' + item.id);
    }
};

</script>

<style lang="scss" scoped>
.articleSearch {
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .luiyan-header {
        width: 100%;
        height: 243px;
        background: #c4c0c0;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-image: url('/image/bg2.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .search-box {
            display: flex;
            border-radius:16px;
            align-items: center;
            background: #fff;
            height: 62px;
            margin-top: 132px;
            width: 936px;
            padding: 5px;
            box-sizing: border-box;
            input {
                    width: 100%;
                    height: 40px;
                    border: 1px solid #cecece;
                    box-sizing: border-box;
                    color: #202020;
                    font-size:20px;
                    border: none;
                    outline: none;
                }
                .submit-btn {
                    width:117px;
                    height:53px;
                    background:#026c71;
                    border-radius:14px;
                    color:#fff;
                    font-size:20px;
                    cursor: pointer;
                    text-align: center;
                    line-height: 53px;
                }
           
        }
    }
    .luiyan-box {
       display: flex;
       flex-direction: column;
       width: 936px;
       .luiyan-box-title {
            color:#5d5d5d;
            font-size:19px;
            padding: 30px 0;
       }
       .luiyan-box-content {
            display: flex;
            flex-direction: column;
            padding-right: 19px;
            margin-right: 50px;
            .luiyan-box-content-item {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                box-sizing: border-box;
                padding-bottom: 11px;
                border-bottom: 1px dashed #707070;
                cursor: pointer;
                .luiyan-box-content {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    border-right:1px solid;
                    border-color:#707070;
                }
            }
          
            .date {
                color:#434343;
                font-size:24px;
            }
            .year {
                color:#b2b2b2;
                font-size:14px;
                margin-top: 3px;
            }
            .content {
                color:#434343;
                font-size:18px;
                &:hover {
                    color:#026c71;
                }
            }
       }
    }
}
</style>
